
import Vue from 'vue'
import BillingMultiplierUnitField from './BillingMultiplierUnitField.vue'
import SeatIncrementCard from './SeatIncrementCard.vue'
import { BillingMultipliers } from '@/types/BillingMultipliers.js'
import { useStore } from '@/store'

export default Vue.extend({
  name: 'BillingMultipliers',
  components: { BillingMultiplierUnitField, SeatIncrementCard },
  computed: {
    billingMultipliers(): BillingMultipliers | null {
      return useStore().billingMultipliersModule.billingMultipliers
    },
    multiplierValues(): BillingMultipliers {
      const defaultBillingMultipliers: BillingMultipliers = {
        pricingModelMultiplier: { entryFee: 0, monthlyFee: 0, yearlyFee: 0 },
        membershipMultiplier: {
          premium: { yearlyOrEntryFee: 0, monthlyFee: 0 },
          pro: { yearlyOrEntryFee: 0, monthlyFee: 0 },
          basic: 0,
        },
        protectionMultiplier: { usbDongle: 0, online: 0 },
        softwareAccessMultiplier: { full: 0, starter: 0, hall: 0 },
        falconMultiplier: { available: 0, notAvailable: 0 },
        licenceSeatIncrements: [],
        entryFeeSeatIncrements: [],
        falconSeatIncrements: [],
      } as BillingMultipliers

      return this.billingMultipliers || defaultBillingMultipliers
    },
  },
  methods: {
    async updateField(updaterFun: (billingMultiplier: BillingMultipliers) => void): Promise<void> {
      const multipliers = structuredClone(this.multiplierValues)
      updaterFun(multipliers)

      if (this.billingMultipliers) {
        // update
        await this.$store.dispatch('billingMultipliersModule/updateBillingException', multipliers)
      } else {
        // create
        await this.$store.dispatch('billingMultipliersModule/createBillingMultipliers', multipliers)
      }
    },
  },
})
